import { Controller } from "@hotwired/stimulus"

// Polls a URL while a pending payment exists. When the server detects a
// status change it broadcasts a Turbo Stream refresh, so this controller
// only needs to trigger the check — it doesn't handle the response.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 15 }
  }

  connect() {
    this.poll()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  poll() {
    fetch(this.urlValue, {
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        "Accept": "text/html"
      }
    }).catch(() => {})

    this.timer = setTimeout(() => this.poll(), this.intervalValue * 1000)
  }
}
